import { useState } from "react";

type PasswordInputProps = {
    label: string;
    value: string | undefined;
    onChange: (value: string) => void;
    placeholder?: string;
    helperText?: string;
    testId?: string;
};

export const PasswordInput = ({ label, value, onChange, placeholder, helperText, testId }: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="text-start mb-3">
            <label className="form-label small fw-semibold text-primary ms-2" htmlFor="password">
                {label}
            </label>
            <div className="position-relative">
                <input
                    type={showPassword ? "text" : "password"}
                    className="form-control pe-5 mb-2"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    data-testid={testId}
                />

                <button
                    type="button"
                    onClick={() => setShowPassword((v) => !v)}
                    className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 text-primary"
                    style={{ textDecoration: "none" }}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                >
                    <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                </button>
            </div>
            {helperText && <div className="badge rounded-pill text-bg-warning text-wrap">{helperText}</div>}
        </div>
    );
};
